export default "__VITE_ASSET__CtKG33c3__"